// extracted by mini-css-extract-plugin
export var readonly = "_fh-1";
export var star = "_fh-0";